import { render, staticRenderFns } from "./ProfitLossPortfolioTableSubCurrent.vue?vue&type=template&id=afb4f94c&"
import script from "./ProfitLossPortfolioTableSubCurrent.vue?vue&type=script&lang=js&"
export * from "./ProfitLossPortfolioTableSubCurrent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports